import { Directive, Input, OnInit } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { UiAriaLabelMonths } from "../date-picker.models";

@Directive({
  selector: "button[header-btn-aria-label]",
  host: {
    "[attr.aria-label]": "ariaLabel",
  },
})
export class HeaderButtonAriaLabelDirective implements OnInit {
  @Input("header-btn-aria-label") public label = "";

  public ariaLabel = "";

  public ngOnInit(): void {
    this.ariaLabel = localize(UiAriaLabelMonths[this.label]);
  }
}
